import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { getFirebaseConfig } from "@/config/firebaseConfig";
// import "../registerServiceWorker";

const config = getFirebaseConfig();
initializeApp(config);
const firebaseMessaging = getMessaging();

if (!isSupported) {
  console.warn(firebaseMessaging);
  console.warn("Firebase Messaging is not supported in this browser.");
}

console.warn(firebaseMessaging);

if (firebaseMessaging) {
  // firebaseMessaging.usePublicVapidKey(
  //   "BM8eXxywknOgVX8VFYdqLg4T37Hiu8UTT3733rR4W28rVfGZelemN_i1udUe6ae6_5e7e66ad9XKL1D90VlZuUw"
  // );
}

console.warn(firebaseMessaging);
// navigator.serviceWorker.getRegistration().then(async (registration) => {
//   if (!firebaseMessaging.vapidKey) {
//     firebaseMessaging.usePublicVapidKey(
//       "BM8eXxywknOgVX8VFYdqLg4T37Hiu8UTT3733rR4W28rVfGZelemN_i1udUe6ae6_5e7e66ad9XKL1D90VlZuUw"
//     );
//     firebaseMessaging.useServiceWorker(registration);
//     console.log("file: firebase.js:24 ~ navigator.serviceWorker.getRegistration ~ firebaseMessaging:", firebaseMessaging);
//   }
// });

export default firebaseMessaging;
